// extracted by mini-css-extract-plugin
export default {"signFormTitle":"Registration_signFormTitle__fZswX","divider":"Registration_divider__KYyJx","logInLink":"Registration_logInLink__gkPgp"};